export default {
  LIST_FETCHED: 'DOWNLOADS_FETCHED',
  LIST_LOAD: 'DOWNLOADS_LOAD',
  ITEM_DETAIL: 'DOWNLOADS_DETAIL',
  BUTTON_LOAD: 'DOWNLOADS_BUTTON_LOAD',
};
